module.exports = __webpack_public_path__ + "img/id.9d3d501f.png";